import {combineReducers} from "redux"

// Reducers
import authReducer from "../../modules/auth/store/reducer"
import recordsReducer from "../../modules/records/store/reducer"
import doctorStatsReducer from "../../modules/doctor-stats/store/reducer"
import SpeedAndAmplitudeReducer from "../../modules/records/store/reducer/SpeedAndAmplitudeReducer"

export default combineReducers({
    "auth": authReducer,
    "records": recordsReducer,
    "doctor-stats": doctorStatsReducer,
    "speedAndAmplitude": SpeedAndAmplitudeReducer
})
